import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { preRegistrationRequest } from "../../../_redux/_actions";
import SignUpForm from "./forms/SignUpForm";
import {
    UiAuthContainer
} from "../../_uiComponents/common/custom/header/UiTopNavElements";

export default function SignUpWrapper() {
    const actionDispatch = useDispatch();
    const { id } = useParams();
    // useEffect(function () {
    //     actionDispatch(preRegistrationRequest({ activationCode: id }));
    // }, []);

    return (
        <>
            <UiAuthContainer>
                <div className="sb-auth-top-signup-wr">
                    <h2>Sign Up</h2>
                    <SignUpForm />
                </div>
            </UiAuthContainer>
        </>
    );
}
